const APIS = {
  DEFAULT_BRANCH: "/logisticservice/api/branch/default-branch/",
  STAFF: "/logisticservice/api/staff/",
  USER: "/usermanagementservice/api/user/",
  USER_PROFILE: "/logisticservice/api/user-profile/",
  CLIENT_TYPE: "/logisticservice/api/client-type/",
  GRID_REPORT_DATA_COURIER: "/projectsettingsservice/api/courier-grid-report/",
  GRID_REPORT_DATA_LOGISTIC:
    "/projectsettingsservice/api/logistic-grid-report/",
  STATUS: "/logisticservice/api/status/",
  PICK_STATUS: "/projectsettingsservice/api/pick-drop-steps/",
  CLIENT_SETTING: "/projectsettingsservice/api/configuration/",
  RUNSHEET_STATUS: "/runsheetservice/api/runsheet-settings/",
  RTV_STATUS: "/projectsettingsservice/api/rtv-order-settings/",
  RTV_BRANCH: "/projectsettingsservice/api/rtv-branch-settings/",
  MANIFEST_STATUS: "/manifestservice/api/manifest-settings/",
  VEHICLE_MANIFEST_STATUS:
    "/vehiclemanifestservice/api/vehicle-manifest-settings/",
  DELIVERY_STATUS: "/logisticservice/api/delivery-settings/",
  PICKUPREQUEST_STATUS: "/pickuprequestservice/api/pickup-request-settings/",
};

export default APIS;
